var React = require('react');

function CheckoutFail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM4 40C4 59.8823 20.1177 76 40 76C59.8823 76 76 59.8823 76 40C76 20.1177 59.8823 4 40 4C20.1177 4 4 20.1177 4 40Z","fill":"#FF1E1E","key":0}),React.createElement("rect",{"width":"49.3331","height":"2.25758","rx":"1.12879","transform":"matrix(0.706977 -0.707236 0.706977 0.707236 21.7143 56.6891)","fill":"#FF1E1E","key":1}),React.createElement("rect",{"width":"49.3331","height":"2.25758","rx":"1.12879","transform":"matrix(0.706977 0.707236 -0.706977 0.707236 23.4083 21.7143)","fill":"#FF1E1E","key":2})]);
}

CheckoutFail.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = CheckoutFail;

CheckoutFail.default = CheckoutFail;
